<div class="content md3-surface">
  <div class="content md3-card-on-surface layout-list-quickfilter">
    <exg-search-bar (Search)="oeList.search($event)"
                    class="span-layout"
                    [placeholder]="'Suche'">
	    <ng-template #rightTemplate>
		    <i (click)="oeList.loadData()"
		       class="search-action fal fa-sync">
		    </i>
		    <i class="search-action fal fa-gears"
		       (click)="openTableSettings($event)">
		    </i>
		    <exg-table-settings #tableDefinitionSettings
		                        [tableDef]="oeList.tableDef"
		                        [metaInfo]="oeList.MetaInfo"
		                        localStorageID="caseTable">
		    </exg-table-settings>
	    </ng-template>
    </exg-search-bar>
    <!-- DataTable -->
    <div class="content">
      <exg-table #oeTable
                 (RowDblClick)="oeList.selectionChanged($event); openDetailsTab()"
                 (RowChange)="oeList.selectionChanged($event)"
                 (FilterActivation)="oeList.loadData()"
                 [selectKey]="'oeID'"
                 [rowSource]="oeList.data"
                 [distinctTableName]="'Dealer'"
                 [displayState]="oeList.state" class="content"
                 [allowSingleSelection]="true" [allowMultiSelection]="false"
                 [metaInfo]="oeList.MetaInfo"
                 (loadDistinct)="getDistinctOE($event)"
                 [tableDef]="oeList.tableDef"
                 [distinctData]="oeList.distinctData"></exg-table>
    </div>
    <!-- Quickfilter -->
    <div class="app-drawer">
	    <i class="fal fa-chevron-right search-filter-action"
	       [tooltip]="getRessource('openWorkspace')"
	       [class.disabled]="!oeList.selectedRow"
	       (click)="openDetailsTab()"
	       flow="left">
	    </i>
	    <i class="search-filter-seperator"></i>
	    <i class="fal fa-plus search-filter-action"
	       [tooltip]="getRessource('openNew')"
	       (click)="openNewOEModal()"
	       flow="left">
	    </i>
	    <i class="fal fa-eye search-filter-action"
	       [tooltip]="getRessource('openEditor')"
	       [class.disabled]="!oeList.selectedRow"
	       (click)="openUpdateModalOe()"
	       flow="left">
	    </i>
	    <ng-container *ngIf="excSecurity.isFeatured('DEVELOPMENT')">
		    <i class="search-filter-seperator"></i>
		    <i class="search-filter-action fa-light fa-list-timeline"
		       [tooltip]="getRessource('history')"
		       flow="left"></i>
	    </ng-container>
    </div>
    <!-- Pager -->
    <exg-pager (PageChange)="oeList.pageChanged($event)"
               [pagingSource]="oeList.paging">
    </exg-pager>
  </div>
</div>
